import {
  EditIcon,
  DeleteIcon,
  PrintIcon,
  CopyIcon,
} from 'components/shared/Icons/ActionIcons';
import { StyledFlex } from 'components/shared/shared.style.';
import Checkbox from 'components/shared/ui/CheckBox';

type Props = {
  id: string;
  send: any;
  print?: boolean;
  edit?: boolean;
  trash?: boolean;
  copy?: any;
  approve?: boolean;
  approvalState?: {
    data: any[];
    onChange: (value: any) => void;
  };
  row?: any;
};

export const Actions = ({
  id,
  send,
  print,
  edit,
  trash,
  copy,
  approve,
  approvalState,
  row,
}: Props) => {
  const handleApprove = () => {
    if (approvalState) {
      approvalState.onChange(row);
    }
  };

  const isChecked = approvalState
    ? Boolean(approvalState.data.find((item: any) => item.ID === id))
    : false;

  return (
    <StyledFlex $gridGap={'10px'} justifyContent='center'>
      {copy && <CopyIcon data-cy='copyIcon' onClick={() => copy(id, true)} />}
      {print && <PrintIcon onClick={() => send({ type: 'getColumnPdf', id })} />}
      {edit && (
        <EditIcon
          className='tableEditIcon'
          data-testid='editIcon'
          onClick={() => send({ type: 'updateStore', id })}
        />
      )}
      {trash && (
        <DeleteIcon
          data-cy='deleteIcon'
          data-testid='deleteIcon'
          onClick={() => send({ type: 'removeFromStore', id })}
        />
      )}
      {approve && row && (
        <div onClick={handleApprove} style={{ cursor: 'pointer' }}>
          <Checkbox checked={isChecked} />
        </div>
      )}
    </StyledFlex>
  );
};
